import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Add payment method screen — shares the View frame with the real content. */
export function AddPaymentMethodPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={320} height={32} />
        </View.Header>
        <View.Body>
          {/* Same rung as the form itself, which is a single `gap-stack` child of the body. Left as direct
              children they would stack at `gap-section` and the placeholder would outgrow the content. */}
          <div className="flex flex-col gap-stack">
            <Skeleton variant="text" width={420} height={20} />
            <Skeleton variant="block" height={40} />
            <Skeleton variant="block" height={72} />
            <Skeleton variant="block" height={72} />
            <Skeleton variant="block" height={72} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
